import { useEffect, useRef, useState } from 'react';

type UseLazySnapshotDeviceLabelsParams = {
  limitSn: string[] | null;
  onLoad: (limitSn: string[]) => Promise<string[]>;
};

type UseLazySnapshotDeviceLabelsResult = {
  expanded: boolean;
  labels: string[] | null;
  loading: boolean;
  toggle: () => Promise<void>;
};

export const useLazySnapshotDeviceLabels = ({
  limitSn,
  onLoad,
}: UseLazySnapshotDeviceLabelsParams): UseLazySnapshotDeviceLabelsResult => {
  const [expanded, setExpanded] = useState(false);
  const [labels, setLabels] = useState<string[] | null>(null);
  const [loading, setLoading] = useState(false);
  const mountedRef = useRef(true);

  useEffect(
    () => () => {
      mountedRef.current = false;
    },
    [],
  );

  const toggle = async (): Promise<void> => {
    const nextExpanded = !expanded;
    setExpanded(nextExpanded);

    if (!nextExpanded || limitSn === null || labels !== null) {
      return;
    }

    setLoading(true);
    let nextLabels: string[];
    try {
      nextLabels = await onLoad(limitSn);
    } catch {
      // Hostnames are display-only; fall back to SNs without surfacing an error.
      nextLabels = limitSn;
    }

    if (!mountedRef.current) {
      return;
    }
    setLabels(nextLabels);
    setLoading(false);
  };

  return { expanded, labels, loading, toggle };
};
